import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import Table from "react-bootstrap/Table";
import {
  Alert,
  Button,
  Col,
  Row,
  Modal,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CancelAutoRenew,
  CreatePymenentUrlFn,
  GetSubScription,
  PaymentGetById,
  RedeemPromoCode,
} from "../../redux/auth-reducer/auth-service";
import {
  canPurchaseSubscription,
  isSubscriptionActive as isServerSubscriptionActive,
  pickCurrentSubscription,
} from "../../utils/helper/helper";
import {
  CHECKOUT_OUTCOME,
  clearCheckoutIntent,
  describePlan,
  readCheckoutIntent,
  startCheckout,
} from "../../utils/helper/checkout";
import { announceBellChanged } from "../../utils/helper/notifications";
import dayjs from "dayjs";
import * as icons from "react-bootstrap-icons";
import { DeleteAccount } from "./DeleteAccount";
import { EmailPreferences } from "./EmailPreferences";

export const Account_settings = () => {
  const [data, setData] = useState(false);
  const [dataItem, setDataItem] = useState([]);
  const [dataSubscription, setDataSubscription] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");
  const [checkoutBusy, setCheckoutBusy] = useState(false);
  /** {message, sessionUrl} - the inline state shown under the plan picker. */
  const [checkoutState, setCheckoutState] = useState(null);
  const [resumeNotice, setResumeNotice] = useState("");
  const [showAutoRenewModal, setShowAutoRenewModal] = useState(false);
  const [pendingAutoRenewCancel, setPendingAutoRenewCancel] = useState(true);
  const [isAutoRenewSaving, setIsAutoRenewSaving] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [validated, setValidated] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [userData, setUserData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
   const [messageSubscribe, setMessageSubscribe] = useState('')

  const sidebarfun = () => setData(!data);
  const handleOptionChange = (e) => setSelectedOption(e.target.value);

  const proceedWithPayment = async () => {
    setCheckoutState(null);
    setCheckoutBusy(true);

    const result = await startCheckout(() =>
      CreatePymenentUrlFn(Number(selectedOption))
    );

    if (result.outcome === CHECKOUT_OUTCOME.REDIRECTING) {
      // This tab is leaving for Stripe: stay disabled, and leave a link behind in case it does
      // not, so the user is never looking at a screen with nothing to click.
      setCheckoutState({ message: "", sessionUrl: result.sessionUrl });
      return;
    }

    setCheckoutBusy(false);

    // The server owns the "no plan switching mid-period" rule and the wording of the rejection,
    // including the date the current subscription ends.
    if (result.outcome === CHECKOUT_OUTCOME.REFUSED) {
      setBlockedMessage(result.message);
      setShowConfirmModal(true);
      return;
    }

    setCheckoutState({ message: result.message, sessionUrl: null });
  };

  const handleSubmitPlayer = async () => {
    if (!selectedOption) return;
    // No client-side pre-check: the server is the single enforcement point. The old
    // remaining-days check both encouraged the stacking this ticket forbids and skipped the
    // warning entirely for anyone inside their last five days.
    await proceedWithPayment();
  };

  const requestAutoRenewChange = (cancel) => {
    setPendingAutoRenewCancel(cancel);
    setShowAutoRenewModal(true);
  };

  const confirmAutoRenewChange = async () => {
    try {
      setIsAutoRenewSaving(true);
      const res = await CancelAutoRenew(pendingAutoRenewCancel);

      // WEB-P1-161: `res.status`, not `res.response.status`. CancelAutoRenew returns the axios
      // response on success and `error?.response` on failure, so the HTTP status sits in the
      // same place either way now; it used to be the raw AxiosError, which nested it one deeper.
      // This branch is the reason apiClient.js hands a permission 401 back untouched instead of
      // treating it as an expired session, so it must not quietly stop firing.
      if (res?.status === 401) {
        toast.error(
          "Your permissions changed - please sign out and sign in again."
        );
        return;
      }

      if (res?.data?.status === true) {
        toast.success(res.data?.message);
        setShowAutoRenewModal(false);
        fetchSubscription();
      } else {
        toast.error(res?.data?.message || "Could not update auto-renewal.");
      }
    } catch (err) {
      toast.error("Could not update auto-renewal");
      console.error(err);
    } finally {
      setIsAutoRenewSaving(false);
    }
  };

  // const handleOneTab = async () => {
  //  if (!selectedOption) return;

  //   if (
  //     dataSubscription?.subscriptionRemainingDays &&
  //     dataSubscription.subscriptionRemainingDays > 5
  //   ) {
  //     setShowConfirmModal(true);
  //     return;
  //   }
  //   // await proceedWithPayment();
  // }

  const handleCodeModelShow = () => setShowPromoModal(true);
  const handleCodeModelClose = () => {
    setShowPromoModal(false);
    setPromoCode("");
    setValidated(false);
  };

  const redeemPromoCode = async (event) => {
    event.preventDefault();
    setValidated(true);
    if (!promoCode.trim()) return;
    try {
      const res = await RedeemPromoCode(promoCode.trim());
      if (res?.data?.status === true) {
        toast.success(res.data?.message);
        handleCodeModelClose();
        fetchSubscription();
        // #227: "Buy Subscription" on the bell is over for a promo grant.
        announceBellChanged();
      } else {
        toast.error(res.data?.message);
      }
    } catch (err) {
      toast.error("Failed to redeem promo code");
      console.error(err);
    }
  };

  const fetchSubscription = async () => {
    try {
      setIsLoading(true);
      const response = await GetSubScription();
      const list = response?.data?.data || [];
      setMessageSubscribe(response?.data?.message)
      // A live Stripe subscription wins over a legacy entitlement, which can carry a
      // far-future end date and would otherwise mask it.
      setDataSubscription(pickCurrentSubscription(list));
    } catch (e) {
      console.error(e);
      setDataSubscription(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  // A checkout interrupted by the sign-in wall lands here when it could not be restarted, so
  // the plan chosen on the marketing page is still selected and the purchase is one press away.
  useEffect(() => {
    const intent = readCheckoutIntent();
    if (!intent) return;
    clearCheckoutIntent();
    setSelectedOption(intent.planId);
    setResumeNotice(
      `Your ${describePlan(
        intent.planId
      )} purchase was not completed. Press Make Payment to finish it.`
    );
  }, []);

  const GetByIdPayment = async (data) => {
    try {
      const response = await PaymentGetById(data); // Call your API function

      setDataItem(response?.data?.data?.dataList || []);
      setUserData(response);
      setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    GetByIdPayment(data);
  }, [currentPage]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: true,
    };
    GetByIdPayment(data);
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const isRole = localStorage.getItem("role");

  // Server-computed. A date comparison in the browser cannot see access revoked before the
  // end date, which is exactly what a failed renewal payment does.
  const isSubscriptionActive = () => isServerSubscriptionActive(dataSubscription);

  // Also server-computed, and for the same reason: the SPA cannot see subscriptionStatus values
  // like past_due or unpaid well enough to reproduce the rule, so it asks rather than re-derives.
  const canPurchase = canPurchaseSubscription(dataSubscription);

  const formatUtc = (value) =>
    value ? dayjs(value + "Z").format("MM/DD/YYYY hh:mm:ss A") : "-";

  const isTrialing = dataSubscription?.subscriptionStatus === "trialing";

  // The user still holds a promo or legacy entitlement, so a new plan will be set to begin when
  // that access runs out rather than billing over the top of it. The 48-hour floor mirrors
  // ConstantValue.StripeMinTrialLeadHours: below it Stripe refuses the trial and the server bills
  // immediately, so promising otherwise here would be a lie.
  const startsAfterCurrentAccess =
    canPurchase &&
    isSubscriptionActive() &&
    !!dataSubscription?.subscriptionEndDate &&
    dayjs(dataSubscription.subscriptionEndDate + "Z").diff(dayjs(), "hour") > 48;

  // What the end date MEANS depends on the state. During a trial it is the first charge, not a
  // renewal, and calling it a renewal is how a user ends up surprised by the charge.
  const endDateLabel = () => {
    if (dataSubscription?.isPaymentFailed) return "Payment outstanding, due";
    if (dataSubscription?.willCancelAtPeriodEnd) return "Access ends";
    if (isTrialing) return "First payment on";
    return "Renews on";
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <Modal show={showPromoModal} centered>
        <Form noValidate validated={validated} onSubmit={redeemPromoCode}>
          <Modal.Header className="promo-code-header promo-close" closeButton>
            <Modal.Title>
              <b>Redeem Promo Code</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="promoCodeInput">
              <InputGroup hasValidation>
                <Form.Control
                  required
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Enter your promo code"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid promo code.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCodeModelClose}>
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Redeem Now
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* States the no-plan-switching rule. This screen previously did the opposite: it
          offered a "Yes, Proceed" button that stacked another period on top. */}
      <Modal show={showConfirmModal} centered onHide={() => setShowConfirmModal(false)}>
        <Modal.Header className="promo-code-header promo-close" closeButton>
          <Modal.Title>
            <b>Plan change unavailable</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{blockedMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAutoRenewModal} centered onHide={() => setShowAutoRenewModal(false)}>
        <Modal.Header className="promo-code-header promo-close" closeButton>
          <Modal.Title>
            <b>
              {pendingAutoRenewCancel
                ? "Cancel auto-renewal"
                : "Resume auto-renewal"}
            </b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* The end date means different things in different states. On a trial it is the first
              charge, so calling it a renewal is exactly how a user is surprised by the payment. */}
          {pendingAutoRenewCancel ? (
            <p>
              Your subscription will not renew. You keep full bidding access
              until{" "}
              <strong>{formatUtc(dataSubscription?.subscriptionEndDate)}</strong>
              , and it expires after that.
              {isTrialing &&
                " You have not been charged for this plan yet, and cancelling now means you will not be."}
            </p>
          ) : isTrialing ? (
            <p>
              Your subscription will start, and the first payment will be taken,
              on{" "}
              <strong>{formatUtc(dataSubscription?.subscriptionEndDate)}</strong>
              .
            </p>
          ) : (
            <p>
              Your subscription will start renewing again on{" "}
              <strong>{formatUtc(dataSubscription?.subscriptionEndDate)}</strong>
              .
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAutoRenewModal(false)}
            disabled={isAutoRenewSaving}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={confirmAutoRenewChange}
            disabled={isAutoRenewSaving}
          >
            {isAutoRenewSaving ? "Saving..." : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Account Settings</h1>
          <div className="group_data_table">
            <div className="subscription d-flex flex-wrap gap-4">
              <div className="subscription_box" style={{ flex: 1 }}>
                <div className="subscription_box-inner">
                  <h4>Subscription Details</h4>
                  {/* isPaymentFailed, not accessRevoked: access is also revoked when a
                      subscription simply ends, and that is not a payment failure (#107). */}
                  {isLoading ? (
                    " "
                  ) : dataSubscription?.isPaymentFailed ? (
                    <button className="bg-danger">Payment failed</button>
                  ) : isSubscriptionActive() &&
                    dataSubscription?.willCancelAtPeriodEnd ? (
                    <Button variant="warning">
                      Cancels {formatUtc(dataSubscription?.subscriptionEndDate)}
                    </Button>
                  ) : isSubscriptionActive() ? (
                    <Button variant="success">Active</Button>
                  ) : dataSubscription?.subscriptionStatus === "canceled" ? (
                    <Button variant="secondary">Canceled</Button>
                  ) : (
                    <button className="bg-danger">Inactive</button>
                  )}
                </div>

                {/* The recovery path after a failed renewal: the Stripe-hosted invoice the
                    user can pay to restore access. Without this they are told nothing. */}
                {!isLoading &&
                  dataSubscription?.isPaymentFailed &&
                  dataSubscription?.hostedInvoiceUrl && (
                    <div className="alert alert-danger mt-2 mb-0" role="alert">
                      Your renewal payment failed and bidding is paused.{" "}
                      <a
                        href={dataSubscription.hostedInvoiceUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Complete payment
                      </a>{" "}
                      to restore access.
                    </div>
                  )}

                {isLoading ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    <div className="subscription_box-inner pb-2 pt-2"></div>
                    <div className="subscription_box-inner">
                      <p>Amount:</p>
                      <p className="fw-bold">{dataSubscription?.amount || 0}</p>
                    </div>
                    {/* This row has always rendered "No" because the API never returned the
                        field. It now tells the truth - including for legacy one-time
                        entitlements, which genuinely do not auto-renew. */}
                    <div className="subscription_box-inner">
                      <p>Auto Renew</p>
                      <p className="fw-bold">
                        {dataSubscription?.isAutoRenew ? "Yes" : "No"}
                      </p>
                    </div>
                    {/* The auto-renewal controls used to sit here. They now live in the panel
                        that replaces the plan picker, next to the reason the picker is gone, so
                        a subscriber sees the state and the action that changes it together. */}
                    <div className="subscription_box-inner">
                      <p>Subscription Type</p>
                      <p className="fw-bold">
                        {dataSubscription?.subscriptionType || "-"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Subscription Start Date & Time</p>
                      <p className="fw-bold text-nowrap">
                        {dataSubscription?.subscriptionStartDate
                          ? dayjs(
                              dataSubscription.subscriptionStartDate + "Z"
                            ).format("MM/DD/YYYY hh:mm:ss A")
                          : "-"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Subscription End Date & Time</p>
                      <p className="fw-bold text-nowrap">
                        {dataSubscription?.subscriptionEndDate
                          ? dayjs(
                              dataSubscription.subscriptionEndDate + "Z"
                            ).format("MM/DD/YYYY hh:mm:ss A")
                          : "-"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Remaining Days:</p>
                      <p className="fw-bold">
                        {dataSubscription?.subscriptionRemainingDays || 0}
                      </p>
                    </div>
                  </>
                )}
              </div>

              <div
                className="subscription_box plan-select-form d-flex flex-column align-items-center"
                style={{ flex: 1 }}
              >
                {/* Offering a plan picker to someone who cannot use it is a dead end: the click
                    goes to the server and comes back as a rejection modal. When the server says
                    the purchase would be refused, this column states the position instead.

                    The picker is REPLACED rather than disabled because the ticket requires the
                    user be told plan switching is unavailable, and a greyed-out button tells
                    nobody anything - it reads as a broken page. */}
                {isLoading ? null : canPurchase ? (
                  <>
                    <h3>Choose your subscription plan</h3>
                    {resumeNotice && (
                      <Alert variant="info" className="mt-2 w-100">
                        {resumeNotice}
                      </Alert>
                    )}
                    <Form className="w-100 text-center d-flex flex-column align-items-center gap-2">
                      <Form.Check
                        type="radio"
                        id="plan-monthly"
                        name="plan"
                        label={<h5>$ 4.99 Monthly </h5>}
                        value="1"
                        checked={selectedOption === "1"}
                        onChange={handleOptionChange}
                      />
                      <span>OR</span>
                      <Form.Check
                        type="radio"
                        id="plan-yearly"
                        name="plan"
                        label={<h5>$ 49.99 Yearly</h5>}
                        value="2"
                        checked={selectedOption === "2"}
                        onChange={handleOptionChange}
                      />
                    </Form>
                    {/* Without this the user reasonably assumes they are being charged today and
                        losing whatever they have already paid for. */}
                    {startsAfterCurrentAccess && (
                      <p className="text-center text-muted mt-3 mb-0">
                        You already have access until{" "}
                        <strong>
                          {formatUtc(dataSubscription?.subscriptionEndDate)}
                        </strong>
                        . A new plan starts when that runs out, so you are not
                        charged twice for the same days.
                      </p>
                    )}
                    <Row className="mt-4 justify-content-center gap-2">
                      <Col xs="auto">
                        <Button
                          disabled={!selectedOption || checkoutBusy}
                          onClick={handleSubmitPlayer}
                        >
                          {checkoutBusy ? "Opening checkout..." : "Make Payment"}
                        </Button>
                      </Col>
                      <Col xs="auto">
                        <Button
                          onClick={handleCodeModelShow}
                          variant="outline-primary"
                        >
                          Promo Code
                        </Button>
                      </Col>
                    </Row>

                    {/* The payment page could not be reached. Says so, and leaves something to
                        press - which is the whole of WEB-P1-116. */}
                    {checkoutState?.message && (
                      <Alert variant="warning" className="mt-3 mb-0 w-100">
                        {checkoutState.message}{" "}
                        <Alert.Link
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            proceedWithPayment();
                          }}
                        >
                          Try again
                        </Alert.Link>
                      </Alert>
                    )}
                    {checkoutState?.sessionUrl && (
                      <Alert variant="info" className="mt-3 mb-0 w-100">
                        If the payment page did not open,{" "}
                        <Alert.Link
                          href={checkoutState.sessionUrl}
                          rel="noopener noreferrer"
                        >
                          open it here
                        </Alert.Link>
                        .
                      </Alert>
                    )}
                  </>
                ) : (
                  <>
                    <h3>Your subscription</h3>
                    <h5 className="mb-1 text-center">
                      {dataSubscription?.subscriptionType || "Subscription"}
                    </h5>
                    {/* Deliberately NOT the amount. The read procedure joins tblSubscription to
                        tblStripe on user and plan, which multiplies rows, and the last one pairs
                        the subscription with the NEWEST ledger row - during a trial that is the
                        as-yet-uncharged one. Showing its amount would claim money that has not
                        been taken. The date below is the honest thing to show. */}
                    <p className="text-center mb-0">
                      {endDateLabel()}{" "}
                      <strong>
                        {formatUtc(dataSubscription?.subscriptionEndDate)}
                      </strong>
                    </p>

                    {/* The server owns this wording, so the panel and the rejection modal behind
                        the checkout call can never contradict each other. */}
                    {dataSubscription?.purchaseBlockedMessage && (
                      <p className="text-center text-muted mt-3 mb-0">
                        {dataSubscription.purchaseBlockedMessage}
                      </p>
                    )}

                    <Row className="mt-4 justify-content-center gap-2">
                      {/* Gated on having a Stripe subscription that is not already cancelling,
                          not on isAutoRenew: that flag is false while a renewal payment has
                          failed, and such a user must still be able to stop the subscription. */}
                      {dataSubscription?.isStripeSubscription &&
                        !dataSubscription?.willCancelAtPeriodEnd && (
                          <Col xs="auto">
                            <Button
                              variant="outline-danger"
                              onClick={() => requestAutoRenewChange(true)}
                            >
                              Cancel auto-renewal
                            </Button>
                          </Col>
                        )}
                      {dataSubscription?.isStripeSubscription &&
                        dataSubscription?.willCancelAtPeriodEnd && (
                          <Col xs="auto">
                            <Button
                              variant="outline-primary"
                              onClick={() => requestAutoRenewChange(false)}
                            >
                              Resume auto-renewal
                            </Button>
                          </Col>
                        )}
                      {/* Kept reachable in both states rather than disappearing with the picker.
                          Redemption while an entitlement overlaps is refused by the server, which
                          says so - better than the button silently not being there. */}
                      <Col xs="auto">
                        <Button
                          onClick={handleCodeModelShow}
                          variant="outline-primary"
                        >
                          Promo Code
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>

            <div className="table-transaction mb-4">
              <h1 className="subscription_heading">Transaction History</h1>
              <div className="table-responsive">
                <Table bordered hover className="table-team border">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Plan Type</th>
                      <th>Transaction ID</th>
                      <th>Transaction Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataItem.length > 0 ? (
                      dataItem.map((item) => (
                        <tr key={item.paymentId || item.id}>
                          <td>{item.name}</td>
                          <td>
                            {item.paymentStatus === "paid" ? (
                              <span className="text-success">Paid</span>
                            ) : item.paymentStatus === "Redeemed" ? (
                              <span className="text-warning">Redeemed</span>
                            ) : item.paymentStatus === "failed" ? (
                              // One declined card attempt, recorded from Stripe's charge.failed (#112).
                              <span className="text-danger">Failed</span>
                            ) : (
                              <span className="text-danger">Unpaid</span>
                            )}
                          </td>
                          <td>{item.amount}</td>
                          <td>{item.planType}</td>
                          <td>{item.paymentId}</td>
                          <td>
                            {item.paymentDate
                              ? dayjs(item.paymentDate + "Z").format(
                                  "MM/DD/YYYY hh:mm:ss A"
                                )
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No transactions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            <EmailPreferences />

            {/* #199: the account-deletion link given to Google Play points at this page. */}
            <DeleteAccount />
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
